<template>
	<div>
		<section v-if="style=='floating'">
			<div v-if="Dialog" class="offline-floating">
				<v-icon class="pulse-icon red--text">mdi-wifi-off</v-icon>
			</div>
		</section>
		<section v-else>
			<v-dialog
				v-model="Dialog"
				fullscreen
				hide-overlay
				transition="dialog-bottom-transition"
			>
				<v-card tile>
					<v-toolbar color="#6200ea" dark dense tile flat>
						<v-toolbar-title>{{
							this.$t("global.components.offline.txtTitle")
						}}</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<Empty
						icon="wifi-off"
						:msg="$t('global.components.offline.txtOffline')"
					/>
				</v-card>
			</v-dialog>
		</section>
	</div>
	
	
</template>

<script>
const Empty = () =>
	import(/* webpackChunkName: "Empty" */ "@/components/empty.vue");
import { mapMutations } from "vuex";

export default {
    name: 'Offline',
    components: { Empty },
	data: () => ({
		style:"floating"
	}),
    computed: {
		Dialog: {
			get: function() {
				return !this.$store.state.ui.online;
			},
			set: function() {
				// this.onlineEvent();
			},
		},
	},
    methods: {
        ...mapMutations("ui", {
			onlineEvent: "onlineEvent",
		}),
    },
	mounted(){
		
	}
};
</script>

<style scoped>
.offline-floating {
  background-color: #fff0f0;
  color: red;
  border: 1px solid red;
  padding: 5px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  z-index: 10000;
  box-shadow: 0 0 10px rgba(255, 0, 0, 0.2);
}

.pulse-icon {
  animation: pulse-red 1.5s infinite;
  margin-right: 4px;
}

.label {
  font-weight: bold;
}

@keyframes pulse-red {
  0% {
    transform: scale(1);
    color: red;
  }
  50% {
    transform: scale(1.3);
    color: #ff4d4d;
  }
  100% {
    transform: scale(1);
    color: red;
  }
}
</style>
